import { Navigate, useLocation } from 'react-router-dom';
import { SettingsLayout } from '@/components/shell/SettingsLayout';
import { ROUTES } from '@/lib/routes';

/**
 * Admin (`/admin/*`) — framed by the shared Settings layout, whose navigation lists the
 * `ADMIN_SECTIONS` from lib/navigation.ts (Admin left the main sidebar on 2026-10-14: it's under the
 * ⚙ in the header). Sends /admin to the first admin page.
 */
export default function AdminPage() {
  const loc = useLocation();
  if (loc.pathname === ROUTES.admin.root || loc.pathname === `${ROUTES.admin.root}/`) {
    return <Navigate to={ROUTES.admin.users} replace />;
  }
  return <SettingsLayout />;
}
